/* eslint-disable max-len */
import {isString} from "lodash"
import API from "../services/API"


const SLACK_URL = "https://bxmcyg3963.execute-api.eu-west-1.amazonaws.com/prod/perkbox-console-slack"

export const question = `
Tell us the what value you think is returned when this function is run.


(function f(){
  function f(){ return 1; }
  return f();
  function f(){ return 2; }
})();


a) 1
b) 2
c) "function"
d) undefined
`

export const correctAnswer = "b"


export const logBanner = () => {
  if (!console.log) {
    return
  }

  const url = "https://image.ibb.co/jDB7fm/logo_small.png"
  const image = new Image()

  image.onload = function() {
    // Inside here we already have the dimensions of the loaded image
    const style = [
      // Hacky way of forcing image's viewport using `font-size` and `line-height`
      "font-size: 1px;",
      `line-height: ${this.height}px;`,

      // Hacky way of forcing a middle/center anchor point for the image
      `padding: ${this.height * 0.5}px ${this.width * 0.5}px;`,

      // Set image dimensions
      `background-size: ${this.width}px ${this.height}px;`,

      // Set image URL
      `background: url(${url});`
    ].join(" ")

    console.log(
      "\n\n%c",
      style,
      "\n\nWe love a riddle at Perkbox HQ.\n",
      question,
      "\n\nPing us your answer along with your details by running the following command...",
      "\n\nhireMe(\"Your answer\", \"Your name\", \"Your email\", \"Your portfolio url\", \"I'm interested in...\", \"Tell us a joke...\");\n\n",
      "\n\nDon't forget to have a look at our jobs page too: https://www.perkbox.com/uk/product-engineering-team/\n\n"
    )
  }

  // Loads the image
  image.src = url
}


export const sendSlackConsoleComms = (answerGiven, name, email, portfolio, interested, message) => {
  if (!console.log) {
    return
  }

  API.post(SLACK_URL, {
    answer: correctAnswer,
    question,
    answerGiven,
    correct: correctAnswer === (isString(answerGiven) ? answerGiven.toLowerCase() : ""),
    name,
    email,
    portfolio,
    interested,
    message
  })
    .then(() => {
      console.log("Ding dong, our slack channel just got a message from you :)")
    })
    .catch(() => {
      console.log("Well, this is embarrassing, we can't even make an ajax request work... try again?!")
    })

  return "Ping ping ping..."
}

export default {question, correctAnswer, logBanner, sendSlackConsoleComms}
